// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.employee-widget {
  min-height: 225px;
}
.employee-widget .publishDate-container {
  font-size: 13px;
  color: #666;
  position: absolute;
  top: 15px;
  right: 15px;
}
.employee-widget .news-stream-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: start !important;
}
.employee-widget .no-news-container {
  text-align: center;
  font-size: 15px;
  color: #666;
  margin-block: auto;
}
.employee-widget .employee-details {
  display: flex;
  justify-content: start;
  flex-direction: column;
  gap: 3px;
}
.employee-widget .details-section {
  display: flex;
  gap: 10px;
  border-radius: 8px;
}
.employee-widget .details-section .icon-container {
  display: flex;
  align-items: flex-start;
  margin-top: 2px;
}
.employee-widget .details-section .icon-container ion-icon {
  font-size: 24px;
  color: #ed143d;
}
.employee-widget .details-section .value {
  display: flex;
  flex-direction: column;
  font-size: 15px;
  font-weight: 600;
  word-break: break-word;
}
.employee-widget .details-section .value .label {
  font-size: 13px;
  color: #666;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/widgets/portal-feed/portal-feed.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;AAAE;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAEJ;AAAE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iCAAA;AAEJ;AAAE;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AAEJ;AAAE;EACE,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,QAAA;AAEJ;AAEE;EACE,aAAA;EACA,SAAA;EAEA,kBAAA;AADJ;AAEI;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AAAN;AACM;EACE,eAAA;EACA,cAAA;AACR;AAGI;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AADN;AAEM;EACE,eAAA;EACA,WAAA;AAAR","sourcesContent":[".employee-widget {\n  min-height: 225px;\n  .publishDate-container {\n    font-size: 13px;\n    color: #666;\n    position: absolute;\n    top: 15px;\n    right: 15px;\n  }\n  .news-stream-container {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    justify-content: start !important;\n  }\n  .no-news-container {\n    text-align: center;\n    font-size: 15px;\n    color: #666;\n    margin-block: auto;\n  }\n  .employee-details {\n    display: flex;\n    justify-content: start;\n    flex-direction: column;\n    gap: 3px;\n \n  }\n\n  .details-section {\n    display: flex;\n    gap: 10px;\n\n    border-radius: 8px;\n    .icon-container {\n      display: flex;\n      align-items: flex-start;\n      margin-top: 2px;\n      ion-icon {\n        font-size: 24px;\n        color: #ed143d;\n      }\n    }\n\n    .value {\n      display: flex;\n      flex-direction: column;\n      font-size: 15px;\n      font-weight: 600;\n      word-break: break-word;\n      .label {\n        font-size: 13px;\n        color: #666;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
